import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Header from '../../../../components/Headers/Header';
import ChatApp from '../../../../components/ChatApp/ChatApp';
import styles from './theme.module.scss';
import './darkModeTheme.css';
import { paragraphThemes } from '../../../../http/themesAPI';
import startIcon from '../../../../assets/images/start-icon.svg';
import LoadingSpinner from '../../../../components/LoadingSpinner/LoadingSpinner';

const Themes = () => {
  const [themeData, setThemeData] = useState([]);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const navigate = useNavigate();

  const themeId = location.state.themeId;
  const ParagraphTitleP = location.state.ParagraphTitle;

  useEffect(() => {
    const fetchingThemes = async () => {
      try {
        const data = await paragraphThemes(themeId);
        setThemeData(data.themes || []);
      } catch (error) {
        console.error('Themes unavailable', error);
      } finally {
        setLoading(false);
      }
    };
    fetchingThemes();
  }, [themeId]);

  console.log(themeData);

  return (
    <div className={styles.themes}>
      {/* Хедер остаётся видимым */}
      <Header />

      {/* Если загрузка, показываем спиннер только внутри контента */}
      <div className={styles.content}>
        {loading ? (
          <div className={styles.spinnerContainer}>
            <LoadingSpinner />
          </div>
        ) : (
          <>
            <div className={styles.themesTitle}>
              <h2>Темы</h2>
            </div>
            <div className={styles.list}>
              {themeData.length > 0 ? (
                themeData.map((theme, index) => (
                  <div
                    key={theme.id}
                    className={`${styles.listContainer} themeListContainer`}
                    onClick={() =>
                      navigate(`stream`, {
                        state: {
                          ParagraphTitle: ParagraphTitleP,
                          themeTitle: theme.title,
                          themeId: theme.id,
                          streamId: theme.webinar_room_id,
                          homeworkId: theme.homework_id,
                        },
                      })
                    }
                  >
                    <div className={styles.image}></div>
                    <div className={styles.information}>
                      <div className={`${styles.title} themeTitle`}>
                        <h3>
                          {index + 1}. {theme.title}
                        </h3>
                      </div>
                      <div className={styles.date}>
                        <p>
                          Добавлено{' '}
                          {new Date(theme.created_at).toLocaleDateString('ru-RU', {
                            day: '2-digit',
                            month: '2-digit',
                            year: 'numeric',
                          })}
                        </p>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <p className={styles.noThemesMessage}>Темы отсутствуют.</p>
              )}
            </div>
          </>
        )}
      </div>
      {/* <ChatApp /> */}
    </div>
  );
};

export default Themes;
